module.exports.pick = (obj, ...attr) => {
  return attr.reduce((acc, k) => {
    if (obj.hasOwnProperty(k)) {
      acc[k] = obj[k];
    }
    return acc;
  }, {});
};



//////////////////
// WEBPACK FOOTER
// ./~/engine.io-client/lib/util.js
// module id = 1134
// module chunks = 2